module.exports = __webpack_public_path__ + "img/banner.69ab3f4f.png";